<script setup lang="ts">
    import { defineProps } from "vue"
    interface Props {
        img: string,
        nivel: string,
        carrera: string,
        complemento?: string,
        frase?: string,
        autor?: string,
    }
    import { onMounted, ref } from "vue";
    let isAnimating = ref(false)
    onMounted(() => {
        setTimeout(() => { isAnimating.value= true }, 50);
    });

    defineProps<Props>();
</script>

<template>
    <section class="flex pt-[88px] lg:pt-[150px] justify-center min-h-[250px] h-full items-center mb-12 w-screen flex-col" style=" min-height:250px">
        <div fetchpriority="high" class="flex items-center justify-center w-screen min-h-[250px] h-full bg-center bg-cover md:bg-[center-right] bg-no-repeat" :style="img">
            <div class="flex justify-center w-full">
                <div class="flex text-justify w-full justify-center md:justify-end items-center max-w-4xl lg:max-w-[1200px] bg-white/50 md:bg-transparent">
                    <div :class="['w-full box h-fit md:h-[500px] md:w-[50%] lg:w-[40%] flex my-12 text-right md:my-0 flex-col justify-center lg:px-0 px-8', { 'visible': isAnimating }]">
                        <h1 v-if="nivel || carrera" class="mb-2 text-black md:text-gray-600">
                            <span v-if="nivel" class="block font-sans text-hwine font-normal mb-0 md:text-[30px] text-[26px]">
                                {{ nivel }}
                            </span>
                            <span v-if="carrera" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="carrera" class="block font-serif text-hwine md:text-[50px] text-[46px]">
                                {{ carrera }}
                            </span>
                            <span v-if="complemento" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="complemento" class="font-serif text-hwine md:text-[36px] text-[32px] mb-2">
                                {{ complemento }}
                            </span>
                        </h1>
                        <p v-if="frase" class="text-black md:text-gray-600 font-times text-[18px]">"{{ frase }}."</p>
                        <p v-if="autor" class="text-black md:text-gray-600 font-times text-right italic">-{{ autor }}-</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.box {
  transform: translateX(160%); /* Fuera del viewport */
  transition: transform 1s ease-in-out;
}

.box.visible {
  transform: translateX(0); /* Posición original */
}
</style>